import { render, staticRenderFns } from "./MoreOrLessProduct.vue?vue&type=template&id=40bfe118&scoped=true"
import script from "./MoreOrLessProduct.vue?vue&type=script&lang=js"
export * from "./MoreOrLessProduct.vue?vue&type=script&lang=js"
import style0 from "./MoreOrLessProduct.vue?vue&type=style&index=0&id=40bfe118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bfe118",
  null
  
)

export default component.exports